/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'
import QS from 'qs'
import { Message } from 'element-ui'

import { JumpToLogin } from '../utils/utils'

// 环境的切换
/*第一层if判断生产环境和开发环境*/
// if (process.env.NODE_ENV === 'production') {
//   /*第二层if，根据.env文件中的VUE_APP_FLAG判断是生产环境还是测试环境*/
//   if (process.env.VUE_APP_FLAG == 'pro') {
//     //production 生产环境
//     axios.defaults.baseURL = 'http://3p.personfg.com' //路径
//   } else {
//     //test 测试环境
//     axios.defaults.baseURL = 'http://3p.personfg.com' //路径
//   }
// } else {
//   axios.defaults.baseURL = '/api'
// }
axios.defaults.baseURL =
  process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BaseAPI : '/api'

// 请求超时时间
axios.defaults.timeout = 10000

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    const token = window.sessionStorage.getItem('token')
    token && (config.headers.Authorization = `Bearer ${token}`)
    return config
  },
  (error) => {
    return Promise.error(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是200的情况
  (error) => {
    if (error.response.status) {
      console.log(error.response)
      switch (error.response.status) {
        case 401:
          // token失效 重新授权
          JumpToLogin()
          break
        case 500:
          Message({
            message: '服务端出错，请联系管理员',
            type: 'error',
          })
          break
        // 其他错误，直接抛出错误提示
        default:
          Message({
            message: error.response.msg,
            type: 'error',
          })
      }
      return Promise.reject(error.response)
    }
  }
)
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function GET(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((res) => {
        if (res.data.code == 200) {
          if (res.data.result) {
            resolve(res.data.result)
          } else {
            resolve(true)
          }
        } else {
          Message({
            message: res.data.msg,
            type: 'error',
          })
          console.error(`${baseUrl}请求报错`, res.data)
          reject(res.data)
        }
      })
      .catch((err) => {
        reject(err.data)
      })
  })
}

export function POSTJSON(url, data, headers) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, {
        headers: Object.assign(
          {
            'Content-Type': 'application/json',
          },
          headers
        ),
      })
      .then((res) => {
        if (res.data.code == 200) {
          if (res.data.result) {
            resolve(res.data.result)
          } else {
            resolve(true)
          }
        } else {
          Message({
            message: res.data.msg,
            type: 'error',
          })
          console.error(`${baseUrl}请求报错`, res.data)
          reject(res.data)
        }
      })
      .catch((err) => {
        reject(err.data)
      })
  })
}

export function DELETE(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        params: params,
      })
      .then((res) => {
        if (res.data.code == 200) {
          if (res.data.result) {
            resolve(res.data.result)
          } else {
            resolve(true)
          }
        } else {
          Message({
            message: res.data.msg,
            type: 'error',
          })
          console.error(`${baseUrl}请求报错`, res.data)
          reject(res.data)
        }
      })
      .catch((err) => {
        reject(err.data)
      })
  })
}
